import React, { useState, useEffect } from 'react';
import { RightMenu } from '../../components/infoTable/rightMenu';
import {
  tableDataValues,
  toggleCurrentChkBox,
  assignCheck,
} from '../../components/infoTable/listTableHelpers';
import { useOnClickOutside } from 'hooks/useOnClickOutside';
import Icon_Folder_01 from '../../images/Icon_Folder_01.svg';
import Icon_File_01 from '../../images/Icon_File_01.svg';
import Magnify_Glass_Icon from '../../images/Icon_Magnify_Glass.png';
import Clear_Search_Icon from '../../images/Icon_Cross_05.png';
import { MyDocumentsApi } from '../../api/myDocumentsApi';
import { useFetch } from 'api';
import { endpoints } from 'endpoints.config';
import {
  selectUpdateMyDocumentsListParentFolder,
  setMyDocumentsListParentFolder,
} from 'reducers/misc';
import { useDispatch, useSelector } from 'react-redux';
import { AxiosError } from 'axios';
import { Spinner } from 'components/spinner/Spinner';
import Back_Btn_Icon from '../../images/Icon_Chevron_Right.png';
import { DownloadDocFileMsg } from './DownloadDocFileMsg';

type Props = {
  infoListData?: any;
  firstColWidth?: number;
  firstColWidthSm?: number;
  listUrl: string;
  updateListSubjectId: number | null;
  parentFoldersId: number | null;
  loadInfoTableList: (listUrl: string, paramsArr?: any) => void;
  dropdrownMenuOptions:
    | ((
        ids: number,
        name: string,
        closeMenu: () => void,
        openCloseState: { open: boolean; id: number | null }
      ) => JSX.Element)
    | null;
  setIsPanelClosed: React.Dispatch<React.SetStateAction<boolean>>;
  isPanelClosed: boolean;
  allowSelectAll: boolean;
  filterTable?: boolean;
  noResultsMessage?: string | null;
  hideSideMenu?: boolean;
  rowHighlight?: boolean;
  hideChkboxCol?: boolean;
  children?: any;
  rowClassname?: (row: any) => string;
};

export const DocumentListTable: React.FC<Props> = ({
  infoListData,
  listUrl,
  updateListSubjectId,
  parentFoldersId,
  loadInfoTableList,
  children,
  setIsPanelClosed,
  allowSelectAll,
}) => {
  const { listData, dataColumnKeys, dataItems, searchString } =
    tableDataValues(infoListData);
  const dispatch = useDispatch();
  const [fileCheckboxList, setFileCheckboxList] = useState<Array<number>>([]);
  const [folderCheckboxList, setFolderCheckboxList] = useState<Array<number>>(
    []
  );
  const [selectedItemsList, setSelectedItemsList] = useState<Array<any>>([]);
  const [selectedRowName, setSelectedRowName] = useState<string>('');
  const [toggleAToZFilter, setToggleAToZFilter] = useState<boolean>(false);
  const [toggleNoPerPageFilter, setToggleNoPerPageFilter] =
    useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState<string>(
    searchString ? searchString : ''
  );
  const [downloadFileMsgPopupOpen, setDownloadFileMsgPopupOpen] = useState<boolean>(false);
  const [downloadDocDetails, setDownloadDocDetails] = useState<any>(null);

  useEffect(() => {
    if (dataItems && dataItems.length > 0) {
      let filteredItems: any = [];

      fileCheckboxList.map((chkbox_item: number) => {
        dataItems.map((data_item: any) => {
          if (chkbox_item === data_item.documents__id) {
            filteredItems.push(data_item);
          }
          return data_item;
        });
        return chkbox_item;
      });

      folderCheckboxList.map((chkbox_item: number) => {
        dataItems.map((data_item: any) => {
          if (chkbox_item === data_item.folders__id) {
            filteredItems.push(data_item);
          }
          return data_item;
        });
        return chkbox_item;
      });

      setSelectedItemsList(filteredItems);
    }
  }, [fileCheckboxList, folderCheckboxList]);

  const aToZToggleBind = useOnClickOutside(() => setToggleAToZFilter(false));
  const noPerPageToggleBind = useOnClickOutside(() =>
    setToggleNoPerPageFilter(false)
  );

  const getCurrentNameListOrder = () => {
    let labelStr = 'Most Recent';

    if (infoListData.sortBy) {
      if (infoListData.sortBy.indexOf('documents__documentname ASC') > -1) {
        labelStr = 'A to Z';
      }

      if (infoListData.sortBy.indexOf('documents__documentname DESC') > -1) {
        labelStr = 'Z to A';
      }
    }

    return labelStr;
  };

  const listFilterToggle = (filter_str: string, filter_value: any) => {
    loadInfoTableList(listUrl, [
      { param: 'subjectsId', value: updateListSubjectId },
      { param: 'parentFoldersId', value: parentFoldersId },
      { param: filter_str, value: filter_value },
    ]);
  };

  const handleItemClick = (isFileItem: any, item: any) => {
    if(isFileItem){
      MyDocumentsApi.viewFile(
        item.documents__id,
        item.list__itemname,
        setDownloadFileMsgPopupOpen,
        setDownloadDocDetails,
      );
    } else {
      dispatch(
        setMyDocumentsListParentFolder({
          parentsFolderId:
            item.folders__id,
          parentsFolderName:
            item.list__itemname,
        })
      );
    }
  };

  return (
    <React.Fragment>
      {listData && (
        <React.Fragment>
          {parentFoldersId ? (
            <DocumentsHeader />
          ) : (
            <div className="DocumentTopPagination">
              <div className="TPInner">
                <div className="BackBtn Inactive">
                  <img src={Back_Btn_Icon} alt="Back to previous page" />
                </div>
                <div className="FolderList">
                  <div className="FolderNameLink">My Documents</div>
                </div>
              </div>
            </div>
          )}

          <div className="DocumentSearchBar">
            <input
              type="text"
              placeholder="Type your search here"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onKeyUp={(e) => {
                if (e.key.toLowerCase() === 'enter') {
                  listFilterToggle('search', searchTerm);
                }
              }}
            />
            {searchTerm &&
              <img
                src={Clear_Search_Icon}
                alt="Clear document search"
                onClick={(e) => {
                  setSearchTerm('');
                  listFilterToggle('search', '');
                }}
                className="ClearDocSearchImg"
              />            
            }            
            <img
              src={Magnify_Glass_Icon}
              alt="Type your search here"
              onClick={(e) => listFilterToggle('search', searchTerm)}
              className="MagnifyGlassImg"
            />
          </div>

          <div className="DocumentMainList">
            <div className="DocMLTable">
              <div className="HdrRow">
                <div className="HRTable">
                  <div className="CellBlock Cell_01"></div>
                  <div className="CellBlock Cell_02">Name</div>
                  <div className="CellBlock Cell_03">Type</div>
                  <div className="CellBlock Cell_04">
                    <div className="SortSelect" {...aToZToggleBind}>
                      <div
                        className="SortBy"
                        onClick={() => setToggleAToZFilter(!toggleAToZFilter)}
                      >
                        <div className="LabelRow">
                          <div className="ToggleIcon"></div>
                          <div className="ToggleTxt">
                            {getCurrentNameListOrder()}
                          </div>
                        </div>
                        {toggleAToZFilter && (
                          <div className="SortOpts">
                            <div
                              className="SORow"
                              onClick={() => listFilterToggle('sortBy', '')}
                            >
                              Most Recent
                            </div>
                            <div
                              className="SORow"
                              onClick={() =>
                                listFilterToggle(
                                  'sortBy',
                                  'documents__documentname ASC'
                                )
                              }
                            >
                              A to Z
                            </div>
                            <div
                              className="SORow"
                              onClick={() =>
                                listFilterToggle(
                                  'sortBy',
                                  'documents__documentname DESC'
                                )
                              }
                            >
                              Z to A
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="SortSelect" {...noPerPageToggleBind}>
                      <div
                        className="SortBy"
                        onClick={() =>
                          setToggleNoPerPageFilter(!toggleNoPerPageFilter)
                        }
                      >
                        <div className="LabelRow">
                          <div className="ToggleIcon"></div>
                          <div className="ToggleTxt">
                            {infoListData.pageSize} per page
                          </div>
                        </div>
                        {toggleNoPerPageFilter && (
                          <div className="SortOpts">
                            <div
                              className="SORow"
                              onClick={() => listFilterToggle('pageSize', 15)}
                            >
                              15 per page
                            </div>
                            <div
                              className="SORow"
                              onClick={() => listFilterToggle('pageSize', 24)}
                            >
                              24 per page
                            </div>
                            <div
                              className="SORow"
                              onClick={() => listFilterToggle('pageSize', 36)}
                            >
                              36 per page
                            </div>
                            <div
                              className="SORow"
                              onClick={() => listFilterToggle('pageSize', 48)}
                            >
                              48 per page
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="ListContainer">
                {dataItems &&
                  dataItems.length > 0 &&
                  dataItems.map((item: any) => {
                    const isFileItem = item.documents__id !== null;

                    const checkboxList = isFileItem
                      ? fileCheckboxList
                      : folderCheckboxList;

                    const setCheckboxList = isFileItem
                      ? setFileCheckboxList
                      : setFolderCheckboxList;

                    const itemSelected = checkboxList.includes(
                      item.documents__id ?? item.folders__id
                    );

                    const columnId = isFileItem
                      ? item.documents__id
                      : item.folders__id;

                    const itemName = item.list__itemname;

                    return (
                      <div
                        className={
                          'ListItem' +
                          (itemSelected ? ' ItemSelected' : '') +
                          (isFileItem ? ' FileItem' : '')
                        }
                        key={
                          'List_Item_' +
                          (item.documents__id
                            ? `D${item.documents__id}`
                            : `F${item.folders__id}`)
                        }
                      >
                        <div className="LIInner">
                          <div className="LITable">
                            <div className="CellBlock Cell_01">
                              <div className="Checkbox">
                                <input
                                  id={
                                    item.documents__id
                                      ? `D${item.documents__id}`
                                      : `F${item.folders__id}`
                                  }
                                  type="checkbox"
                                  checked={assignCheck(checkboxList, columnId)}
                                  onChange={() => {
                                    toggleCurrentChkBox(
                                      checkboxList,
                                      setCheckboxList,
                                      setSelectedRowName,
                                      columnId,
                                      itemName,
                                      allowSelectAll,
                                      null,
                                      null
                                    );
                                  }}
                                />
                                <label
                                  className="CustomInput"
                                  htmlFor={
                                    item.documents__id
                                      ? `D${item.documents__id}`
                                      : `F${item.folders__id}`
                                  }
                                />
                              </div>
                            </div>
                            <div className="CellBlock Cell_02">
                              <div className="LINameRow">
                                <div className="NameRowIcon">
                                  <img
                                    src={
                                      isFileItem ? Icon_File_01 : Icon_Folder_01
                                    }
                                    alt={itemName}
                                  />
                                </div>
                                <div className="NameRowTxt">
                                  <div className="TxtLabel">
                                    {item.list__itemname}
                                  </div>
                                  <div className="SmRowDetails">
                                    <div className="RowLabel">Name</div>
                                    <div className="RowValue">
                                      {item.list__itemname}
                                    </div>
                                    <div className="LineSpacer3"></div>
                                    <div className="RowLabel">Type</div>
                                    <div className="RowValue TypeValue">
                                      {item.list__itemtype}
                                    </div>
                                    <div className="LineSpacer3"></div>
                                    <div
                                      className="Btn BtnOrange"
                                      onClick={() => {
                                        handleItemClick(isFileItem, item);
                                      }}
                                    >
                                      {isFileItem ? 'View File' : 'Open Folder'}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="CellBlock Cell_03">
                              {item.list__itemtype}
                            </div>
                            <div className="CellBlock Cell_04">
                              <div
                                className="Btn BtnOrange"
                                onClick={() => {
                                  handleItemClick(isFileItem, item);
                                }}
                              >
                                {isFileItem ? 'View File' : 'Open Folder'}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
            <RightMenu
              name={selectedRowName}
              checkboxList={[...fileCheckboxList, ...folderCheckboxList]}
              setIsPanelClosed={setIsPanelClosed}
              selectedItemsList={selectedItemsList}
            >
              {children}
            </RightMenu>

            {downloadFileMsgPopupOpen && (
              <DownloadDocFileMsg
                panelOpen={downloadFileMsgPopupOpen}
                togglePanelOpen={setDownloadFileMsgPopupOpen}
                downloadDocDetails={downloadDocDetails}
                setDownloadDocDetails={setDownloadDocDetails}
              />
            )}            
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

type DocumentsHeaderProps = {};
type FolderStructureResponse = {
  details: {
    folderStructure: Array<{
      parentFolderName: string;
      parentFoldersId: number;
    }>;
  };
};

const DocumentsHeader: React.FC<DocumentsHeaderProps> = () => {
  const dispatch = useDispatch();
  const { parentFoldersId, parentFoldersName } = useSelector(
    selectUpdateMyDocumentsListParentFolder
  );
  const { loading, data, error } = useFetch<FolderStructureResponse>(
    endpoints.myDocuments.folderStructure,
    { params: { Id: parentFoldersId } }
  );

  if (error) {
    let errorMessage = 'An error occurred while loading the folder structure.';
    if ((error as AxiosError)?.response?.data?.errors?.length > 0) {
      errorMessage =
        (error as AxiosError).response?.data?.errors[0].errorMessage ===
        'Invalid_FoldersId'
          ? 'Invalid folder ID provided.'
          : 'An error occurred while loading the folder structure.';
    }
    return (
      <div className="DocumentTopPagination">
        <div className="TPInner">
          <div className="BackBtn Inactive">
            <img src={Back_Btn_Icon} alt="Back to previous page" />
          </div>
          <div className="FolderList">
            <div className="FolderNameLink ErrorMessage">{errorMessage}</div>
          </div>
        </div>
      </div>
    );
  }

  if (!loading && data) {
    return (
      <div className="DocumentTopPagination">
        <div className="TPInner">
          <div
            className="BackBtn"
            onClick={() => {
              const lastFolder = data.details.folderStructure.pop();
              dispatch(
                setMyDocumentsListParentFolder({
                  parentsFolderId: lastFolder?.parentFoldersId ?? null,
                  parentsFolderName: lastFolder?.parentFolderName ?? null,
                })
              );
            }}
          >
            <img src={Back_Btn_Icon} alt="Back to previous page" />
          </div>
          <div className="FolderList">
            <div
              className="FolderNameLink"
              onClick={() => {
                dispatch(
                  setMyDocumentsListParentFolder({
                    parentsFolderId: null,
                    parentsFolderName: null,
                  })
                );
              }}
            >
              My Documents
            </div>
            {data.details.folderStructure.map((folder, index) =>
              index !== 0 ? (
                <React.Fragment key={folder.parentFoldersId}>
                  <div className="ArrowLinkImg">&gt;</div>
                  <div
                    className="FolderNameLink"
                    onClick={() => {
                      dispatch(
                        setMyDocumentsListParentFolder({
                          parentsFolderId: folder.parentFoldersId,
                          parentsFolderName: folder.parentFolderName,
                        })
                      );
                    }}
                  >
                    {folder.parentFolderName}
                  </div>
                </React.Fragment>
              ) : null
            )}
            <div className="ArrowLinkImg">&gt;</div>
            <div className="FolderNameLink">{parentFoldersName}</div>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="DocumentTopPagination">
      <div className="TPInner">
        <Spinner positionAbsolute />
      </div>
    </div>
  );
};
